import { PropsWithChildren } from 'react'
import { Auth0Provider } from '@auth0/auth0-react'
import { PrimeReactProvider } from 'primereact/api'

import AuthProvider from './AuthContext'
import ToastProvider from './ToastContext'
import ApiProvider from './ApiContext'
import UserProvider from './UserContext'
import EulaProvider from './EulaContext'
import ArchiveProvider from './ArchiveContext'

import { getEnvString } from '../../tools/env'

export default function ContextStack({ children }: PropsWithChildren) {
    return (
        <PrimeReactProvider>
            <Auth0Provider
                domain={getEnvString('AUTH_DOMAIN')}
                clientId={getEnvString('AUTH_CLIENT_ID')}
                onRedirectCallback={(appState) => {
                    history.pushState({}, '', appState?.href)
                }}
                // To avoid auth quirks on localhost with certain browsers (e.g. Brave)
                //  we make sure to cache auth in localstorage when applicable.
                cacheLocation={location.hostname === 'localhost' ? 'localstorage' : 'memory'}
                authorizationParams={{
                    redirect_uri: window.location.origin,
                    audience: getEnvString('AUTH_AUDIENCE'),
                }}
            >
                <AuthProvider>
                    <ToastProvider>
                        <ApiProvider>
                            <ArchiveProvider>
                                <UserProvider>
                                    <EulaProvider>
                                        {/* prettier-ignore */}
                                        {children}
                                    </EulaProvider>
                                </UserProvider>
                            </ArchiveProvider>
                        </ApiProvider>
                    </ToastProvider>
                </AuthProvider>
            </Auth0Provider>
        </PrimeReactProvider>
    )
}
